import React from "react";
import { JSInputComponent, JSInputProps } from "../JamezzStylesCSSInput";
import FormSelect from "../../../../../../components/Forms/FormSelect";
import { MenuItem } from "@mui/material";
import { useWatch } from "react-hook-form";

const qrSizes = ["auto", 0, 8, 16, 24, 32];
const kioskSizes = ["auto", 0, 4, 8, 16, 32, 48, 64, 128, 256, 300];

function PaddingAndMargin({ name, cssProperty, required }: JSInputProps) {
  const salesareaType = useWatch({ name: "salesarea_type" });

  const sizes = salesareaType === "KIOSK" ? kioskSizes : qrSizes;

  return (
    <FormSelect
      name={name}
      options={[
        <MenuItem key={"default"} value={""}>
          Default
        </MenuItem>,
        sizes.map((size) => {
          return (
            <MenuItem key={size} value={`${size}px`}>
              {size}
            </MenuItem>
          );
        }),
      ]}
      rules={{ required }}
    />
  );
}

export const JSPaddingAndMarginComponent: JSInputComponent = {
  Component: PaddingAndMargin,
  handlesCssProperties: [
    "padding",
    "margin",
    "paddingBottom",
    "paddingLeft",
    "paddingRight",
    "paddingTop",
    "marginBottom",
    "marginTop",
    "marginLeft",
    "marginRight",
  ],
};
